import { toast } from 'react-toastify'
import {
  addLeave,
  addManualLeave,
  getFilterLeaves,
  getLeaveBalancesById,
  getLeaveEmails,
  getLeavesBalance,
  getPieChartDatas,
  getallUsersLeaves,
  handleLeaveAction,
  handleLeaveApproves,
  handleLeaveRejects,
} from '../../../api/LeaveAPI'
import { getDate, Message } from '../../../_metronic/helpers'
import { UserModel, setupAxios } from '../../modules/auth'
import Swal, { SweetAlertResult } from 'sweetalert2'
import { AlertProps } from '../../data/AlertDefaults'
import { API_BASE_URL, UPDATE_MESSAGE } from '../../../utils/contants'
import striptags from 'striptags'
import API from '../../../api/APIUrl'
import { InputErrorType, SubmitAPIStatusType } from '../../types/OtherTypes'

export const handleInputChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setInputField: Function,
  inputField: {
    sender: string
    recipients: {
      to: string[]
      cc: string[]
    }
    leaveType: string
    reason: string
    leaveDate: {
      startDate: string
      endDate: string
      type: string
    }[]
  },
  fieldName: string
) => {
  const target = event.target

  if (target.type === 'radio' && target.checked) {
    setInputField((prevInputField) => ({
      ...prevInputField,
      leaveDate: [
        {
          ...prevInputField.leaveDate[0],
          type: target.value,
        },
      ],
    }))
  } else {
    setInputField((prevInputField) => ({
      ...prevInputField,
      [fieldName]: target.type === 'checkbox' ? target.checked : target.value,
    }))
  }
}

// export const getLeave = (
//   currentUser: UserModel | undefined,
//   setLeave: Function,
//   setAPIStatus: Function,
//   action
// ) => {
//   setAPIStatus((prev: any) => ({ ...prev, loading: true }))
//   getLeaveEmails(currentUser?.id, action).then((res: any) => {
//     if (res.statusCode === 200) {
//       setLeave(res.data)
//       setAPIStatus((prev: any) => ({ ...prev, loading: false }))
//     } else {
//       setAPIStatus((prev: any) => ({ ...prev, loading: false, error: res.message }))
//     }
//   })
// }
export const getLeave = (
  currentUser: UserModel | undefined,
  setLeave: Function,
  setAPIStatus: Function,
  action,
  options?: {
    page?: number
    pageSize?: number
    status?: string
    search?: string
    applicantId?: string
    leaveId?: string
    onPageInfo?: (pagination: any, statusCounts: Record<string, number>) => void
    isCurrent?: () => boolean
  }
) => {
  if (!options?.isCurrent || options.isCurrent()) {
    setAPIStatus((prev: any) => ({ ...prev, loading: true, error: null }))
  }
  const normalizedRoleName = currentUser?.role?.name
    ?.trim()
    .toUpperCase()
    .replace(/_/g, ' ')
  const isSuperAdmin = normalizedRoleName === 'SUPER ADMIN'
  const isAdmin = normalizedRoleName === 'ADMIN'
  // Super Admin and Admin should receive all relevant leave requests
  if (isSuperAdmin || isAdmin) {
    return getLeaveEmails(currentUser?.id, action, options).then((res: any) => {
      if (options?.isCurrent && !options.isCurrent()) return
      if (res.statusCode === 200) {
        const rows = Array.isArray(res.data) ? res.data : Array.isArray(res.data?.items) ? res.data.items : []
        setLeave(rows)
        if (res.data?.pagination) options?.onPageInfo?.(res.data.pagination, res.data.statusCounts || {})
        setAPIStatus((prev: any) => ({
          ...prev,
          loading: false,
          error: null,
        }))
      } else {
        setAPIStatus((prev: any) => ({
          ...prev,
          loading: false,
          error: res.message || 'Leave applications could not be loaded.',
        }))
      }
    }).catch((error: any) => {
      if (options?.isCurrent && !options.isCurrent()) return
      setAPIStatus((prev: any) => ({
        ...prev,
        loading: false,
        error: error?.response?.data?.message || error?.message || 'Leave applications could not be loaded.',
      }))
    })
  } else {
    // Existing behavior for other roles
    return getLeaveEmails(currentUser?.id, action, options).then((res: any) => {
      if (options?.isCurrent && !options.isCurrent()) return
      if (res.statusCode === 200) {
        const rows = Array.isArray(res.data) ? res.data : Array.isArray(res.data?.items) ? res.data.items : []
        setLeave(rows)
        if (res.data?.pagination) options?.onPageInfo?.(res.data.pagination, res.data.statusCounts || {})
        setAPIStatus((prev: any) => ({
          ...prev,
          loading: false,
          error: null,
        }))
      } else {
        setAPIStatus((prev: any) => ({
          ...prev,
          loading: false,
          error: res.message || 'Leave applications could not be loaded.',
        }))
      }
    }).catch((error: any) => {
      if (options?.isCurrent && !options.isCurrent()) return
      setAPIStatus((prev: any) => ({
        ...prev,
        loading: false,
        error: error?.response?.data?.message || error?.message || 'Leave applications could not be loaded.',
      }))
    })
  }
}
export const getFilterLeave = (
  currentUser: UserModel | undefined,
  setLeave: Function,
  setAPIStatus: Function,
  action
) => {
  setAPIStatus((prev: any) => ({ ...prev, loading: true }))
  getFilterLeaves(currentUser?.id, action).then((res: any) => {
    if (res.statusCode === 200) {
      setLeave(res.data)
      setAPIStatus((prev: any) => ({ ...prev, loading: false }))
    } else {
      setAPIStatus((prev: any) => ({ ...prev, loading: false, error: res.message }))
    }
  })
}
export const getLeaveBalances = (
  currentUser: UserModel | undefined,
  setBalance: Function,
  setAPIStatus: Function
) => {
  setAPIStatus((prev: any) => ({ ...prev, loading: true, error: null }))
  
  if (!currentUser?.id) {
    setAPIStatus((prev: any) => ({ 
      ...prev, 
      loading: false, 
      error: 'User not found. Please refresh the page and try again.' 
    }));
    return;
  }

  getLeavesBalance(currentUser.id).then((res: any) => {
    if (res.statusCode === 200) {
      setBalance(res.data || []);
      setAPIStatus((prev: any) => ({ ...prev, loading: false, error: null }));
    } else {
      let errorMessage = res.message || 'Failed to fetch leave balances';
      
      // Provide more specific error messages based on the response
      if (res.statusCode === 404) {
        errorMessage = 'No leave policies found for your employment type. Please contact HR to set up your leave policies.';
      } else if (res.statusCode === 400) {
        errorMessage = 'Invalid request. Please check your user profile and employment details.';
      } else if (res.statusCode === 500) {
        errorMessage = 'Server error while calculating leave balances. Please try again later or contact support.';
      }
      
      setBalance([]);
      setAPIStatus((prev: any) => ({ ...prev, loading: false, error: errorMessage }));
    }
  }).catch((error) => {
;
    setBalance([]);
    setAPIStatus((prev: any) => ({ 
      ...prev, 
      loading: false, 
      error: 'Network error. Please check your connection and try again.' 
    }));
  });
}
export const getPieChartData = (
  currentUser: UserModel | undefined,
  setPieChartData: Function,
  setAPIStatus: Function
) => {
  setAPIStatus((prev: any) => ({ ...prev, loading: true }))
  getPieChartDatas(currentUser?.id).then((res: any) => {
    if (res.statusCode === 200) {
      setPieChartData(res.data)
      setAPIStatus((prev: any) => ({ ...prev, loading: false }))
    } else {
      setAPIStatus((prev: any) => ({ ...prev, loading: false, error: res.message }))
    }
  })
}
export const handleInputChanges = (
  event: React.SyntheticEvent,
  section: string,
  setInputField: Function,
  inputField: any
) => {
  let target = event.target as HTMLInputElement

  setInputField({
    ...inputField,
    [section]: {
      ...inputField[section],
      [target.name]: target.type === 'checkbox' ? target.checked : target.value,
    },
  })
}

export const handleSubmit = (
  inputField: {
    sender: string
    attachment: File | null
    isAttachmentRequired: boolean
    recipients: {
      to: string
      cc: string[]
    }
    leaveType: string
    reason: string
    reasonId: string
    leaveDate: {
      startDate: string
      endDate: string
      type: string
    }[]
  },
  initialState: {
    sender: string
    recipients: {
      to: string
      cc: string[]
    }
    attachment: File | null
    isAttachmentRequired: boolean
    leaveType: string
    reason: string
    reasonId: string
    leaveDate: {
      startDate: string
      endDate: string
      type: string
    }[]
  },
  setLeave: Function,
  setInputField: Function,
  editId: string | null,
  setAPIStatus: Function,
  setInputError: Function,
  setSubmitAPIStatus: Function,
  validateForm: Function,
  setMyLeaveModalOpen: Function,
  fetchData: Function
) => {
  
  const { errors, cnt } = validateForm(inputField)
  let { formattedDate } = getDate()
  setInputError(errors)
  
  
  if (cnt === 0) {
    let isPassDatedLeave = false
    inputField.leaveDate.forEach((dateSet, index) => {
      if (dateSet.startDate < formattedDate) {
        isPassDatedLeave = true
      }
    })
    if (isPassDatedLeave) {
      Swal.fire({
        ...AlertProps,
        icon: 'warning',
        title: `Past-Dated Leave Warning`,
        html: `
      <strong>Warning:</strong> You are submitting a <strong>past-dated leave request</strong>.<br/><br/>
      This leave <strong>cannot be cancelled or rejected</strong> once submitted.<br/><br/>
      Please <strong>double-check your leave details</strong> before proceeding.<br/><br/>
      <strong>Are you sure you want to submit?</strong>
    `,
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          setSubmitAPIStatus((prev: any) => ({ ...prev, loading: true }))
          addLeave(inputField).then((res) => {
            if (res.statusCode === 201) {
              setMyLeaveModalOpen(false)
              toast.success(res.message)
              fetchData()
              setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }))
              setInputField(initialState)
            } else {
              Message(res.message, 'error')
              setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }))
            }
          })
        }
      })
    } else {
      setSubmitAPIStatus((prev: any) => ({ ...prev, loading: true }))
      addLeave(inputField).then((res) => {
        if (res.statusCode === 201) {
          setMyLeaveModalOpen(false)
          toast.success(res.message)
          fetchData()
          
          // Refresh leave balances to reflect the new submission
          getLeavesBalance(inputField.sender).then((balanceRes: any) => {
            if (balanceRes.statusCode === 200) {
              // Note: This would need to be passed down from the parent component
              // For now, we'll rely on the main fetchData() call
            } else {
              console.warn('Failed to refresh leave balances:', balanceRes.message);
            }
          }).catch((error) => {
            console.error('Error refreshing leave balances:', error);
          });
          
          setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }))
          setInputField(initialState)
        } else if (
          res.message?.includes('Please attach a document to support your leave request.')
        ) {
          Message(res.message, 'error')
          setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({ ...prev, loading: false }))
          setInputField((prevInputField) => ({
            ...prevInputField,
            isAttachmentRequired: true,
          }))
        } else {
          Message(res.message, 'error')
          setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }))
        }
      }).catch(error => {
        console.error('addLeave API error:', error);
        Message('Failed to submit leave request', 'error')
        setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }))
      })
    }
  }
}

export const validateForm = (
  inputField: {
    recipients: { to: string[]; cc: string[] }
    attachment: File | null
    isAttachmentRequired: boolean
    leaveType: string
    reason: string
    reasonId: string
    description: string
    leaveDate: {
      startDate: string
      endDate: string
      type: string
      startTime?: string
      endTime?: string
    }[]
  }
) => {
  let cnt = 0
  const errors: any = {}
  const reasonWithoutTags = striptags(inputField?.reason).trim()

  if (
    !inputField.recipients ||
    !inputField.recipients.to ||
    inputField.recipients.to.length === 0
  ) {
    cnt = cnt + 1
    errors.to = 'Please select at least one recipient.'
  }

  const totalLeaveDays = inputField.leaveDate.reduce((acc, curr) => {
    const start = new Date(curr.startDate)
    const end = new Date(curr.endDate)

    if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
      const diffInTime = end.getTime() - start.getTime()
      const diffInDays = diffInTime / (1000 * 3600 * 24) + 1
      return acc + diffInDays
    }

    return acc
  }, 0)

  // Only validate leaveType if total days <= 1
  if (totalLeaveDays <= 1 && !inputField.leaveType) {
    errors.leaveType = 'Leave type is required for single-day leave.'
  }

  inputField.leaveDate.forEach((dateSet, index) => {
    if (!dateSet.startDate) {
      cnt = cnt + 1
      errors[`startDate${index}`] = 'Please select/enter Start Date.'
    }

    if (!dateSet.endDate) {
      cnt = cnt + 1
      errors[`endDate${index}`] = 'Please select/enter End Date.'
    } else if (new Date(dateSet.startDate) > new Date(dateSet.endDate)) {
      cnt = cnt + 1
      errors[`endDate${index}`] = 'End Date must not be earlier than the Start Date.'
    }

    if (!dateSet.type) {
      cnt = cnt + 1
      errors[`type${index}`] = 'Please select a Type.'
    }

    let nextIndex = index + 1
    while (nextIndex < inputField.leaveDate.length) {
      const nextDateSet = inputField.leaveDate[nextIndex]
      if (
        dateSet.startDate === nextDateSet.startDate ||
        dateSet.startDate === nextDateSet.endDate ||
        dateSet.endDate === nextDateSet.startDate ||
        dateSet.endDate === nextDateSet.endDate
      ) {
        cnt = cnt + 1
        errors[`startDate${nextIndex}`] =
          'Leaves for the selected date have already been requested. Kindly choose an alternate date accordingly.'
      }
      nextIndex++
    }
  })

  if (inputField.leaveDate.length > 1) {
    const firstDateSet = inputField.leaveDate[0]
    const lastDateSet = inputField.leaveDate[inputField.leaveDate.length - 1]

    for (let i = 1; i < inputField.leaveDate.length - 1; i++) {
      const currentDateSet = inputField.leaveDate[i]

      if (
        (new Date(currentDateSet.startDate) >= new Date(firstDateSet.startDate) &&
          new Date(currentDateSet.startDate) <= new Date(firstDateSet.endDate)) ||
        (new Date(currentDateSet.endDate) >= new Date(firstDateSet.startDate) &&
          new Date(currentDateSet.endDate) <= new Date(firstDateSet.endDate)) ||
        (new Date(currentDateSet.startDate) <= new Date(firstDateSet.startDate) &&
          new Date(currentDateSet.endDate) >= new Date(firstDateSet.endDate))
      ) {
        cnt = cnt + 1
        errors[`startDate${i}`] =
          'Leaves for the selected date have already been requested. Kindly choose an alternate date accordingly.'
      }
    }

    if (
      (new Date(lastDateSet.startDate) >= new Date(firstDateSet.startDate) &&
        new Date(lastDateSet.startDate) <= new Date(firstDateSet.endDate)) ||
      (new Date(lastDateSet.endDate) >= new Date(firstDateSet.startDate) &&
        new Date(lastDateSet.endDate) <= new Date(firstDateSet.endDate)) ||
      (new Date(lastDateSet.startDate) <= new Date(firstDateSet.startDate) &&
        new Date(lastDateSet.endDate) >= new Date(firstDateSet.endDate))
    ) {
      cnt = cnt + 1
      errors[`startDate${inputField.leaveDate.length - 1}`] =
        'Leaves for the selected date have already been requested. Kindly choose an alternate date accordingly.'
    }
  }

  // Only require reasonId for Casual Leave (other leave types don't have reasons dropdown)
  const currentLeaveType = inputField.leaveType?.toLowerCase() || '';
  if (currentLeaveType.includes('casual')) {
    if (!inputField.reasonId || inputField.reasonId.trim() === '') {
      cnt = cnt + 1;
      errors.reasonId = 'Please select a valid reason for casual leave.';
    } else {
    }
  }

  // Validate description field for Casual Leave only (other leave types use reason field)
  if (currentLeaveType.includes('casual')) {
    if (!inputField.description || !inputField.description.trim()) {
      cnt = cnt + 1
      errors.description = 'Please provide a description for your leave request.'
    } else if (inputField.description.trim().length > 500) {
      cnt = cnt + 1
      errors.description = 'Description must not exceed 500 characters.'
    }
  }

  // Legacy reason field validation for backward compatibility (non-casual leave types)
  if (!currentLeaveType.includes('casual')) {
    if (!inputField.reason.trim()) {
      cnt = cnt + 1
      errors.reason = 'Please enter a Reason.'
    } else if (!reasonWithoutTags || reasonWithoutTags.trim().length > 300) {
      cnt = cnt + 1
      errors.reason = 'Reason must not exceed 300 characters.'
    }
  }

  // Leave Type Specific Validations
  const leaveTypeName = inputField.leaveType?.toLowerCase() || '';

  // SHORT LEAVE VALIDATIONS
  if (leaveTypeName.includes('short')) {
    // For Short Leave, employee will specify exact times in the reason field
    // Backend will validate the actual duration based on reason content and selected type (First Half/Second Half)
    // Monthly usage check would be handled by backend API
  }

  // EARNED LEAVE VALIDATIONS  
  if (leaveTypeName.includes('earned')) {
    // Service period validation (1 year) already handled in frontend
    // Advance notice validation (7 days) already handled in frontend
    // Minimum duration validation (1 day) already handled in frontend
  }

  // COMP-OFF VALIDATIONS
  if (leaveTypeName.includes('comp') || leaveTypeName.includes('compensatory')) {
    // 6-hour work requirement validation would be handled by backend
    // Within 1 month usage validation already handled in frontend
  }

  // LWP VALIDATIONS
  if (leaveTypeName.includes('without pay') || leaveTypeName.includes('lwp')) {
    // Most LWP validations are policy-based and handled in backend
    // Auto-assignment when other leaves exhausted is backend logic
  }

  let fileregex = /^.+\.(png|jpg|pdf|jpeg)$/i

  // Enhanced attachment validation with better debugging
  // Only validate attachment if it's provided (optional for emergency leave)
  if (inputField?.attachment) {
    if (!fileregex.test(inputField?.attachment?.name ?? '')) {
      cnt = cnt + 1
      errors.attachment = 'Attachment type is not allowed. Please upload PNG, JPG, PDF, or JPEG files only.'
    } else {
    }
  }

  return { errors, cnt }
}

export const formatDates = (dateString) => {
  if (!dateString) return '-'

  const dateObject = new Date(dateString)

  if (isNaN(dateObject.getTime())) {
    console.error('Invalid date string:', dateString)
    return '-'
  }

  return dateObject.toISOString().split('T')[0]
}

export const handleCancelButtonClick = async (
  leaveId,
  currentUser,
  setLeave,
  setAPIStatus,
  action,
  fetchData
) => {
  Swal.fire({
    ...AlertProps,
    icon: 'warning',
    title: `Are you sure you want to cancel?`,
  }).then(async (result: any) => {
    if (result.isConfirmed) {
      const { token } = setupAxios()
      const res = await fetch(API_BASE_URL + `/${API.LEAVEREQUEST}/${leaveId}/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          // 'X-tenant-Id': `${tenantId}`,
        },
        body: JSON.stringify({
          status: 'CANCELLED',
          remarks: 'Cancelled',
          userId: currentUser.id,
        }),
      })

      let response = await res.json()

      if (response.statusCode === 200) {
        getLeave(currentUser, setLeave, setAPIStatus, action)
        fetchData()
        toast.success(response.message)
      } else {
        Message(response.message, 'error')
      }
    }
  })
}

export const handleLeaveApprove = async (
  leaveId,
  currentUser,
  setLeave,
  setAPIStatus,
  action,
  fetchData
) => {
  Swal.fire({
    ...AlertProps,
    icon: 'warning',
    title: `Are you sure you want to approved?`,
  }).then(async (result: any) => {
    if (result.isConfirmed) {
      handleLeaveApproves(leaveId, currentUser).then((res: any) => {
        if (res.statusCode === 200) {
          getLeave(currentUser, setLeave, setAPIStatus, action)
          fetchData()

          toast.success(res.message)
        } else {
          Message(res.message, 'error')
        }
      })
    }
  })
}
export const handleLeaveActions = async (
  formField: { leaveId: string; currentUser: UserModel | undefined; status: string; reason: string; ignoreClValidation?: boolean },
  setReason,
  setReasonModal,
  setError,
  setLeave,
  setAPIStatus,
  setSubmitAPIStatus,
  action,
  fetchData
) => {
  let cnt = 0
  let error: InputErrorType = {}
  if (!formField?.reason) {
    cnt = cnt + 1
    error.reason = 'Remark is required'
  }
  setError(error)
  if (cnt == 0) {
    Swal.fire({
      ...AlertProps,
      icon: 'warning',
      title:
        formField?.status === 'APPROVED'
          ? `Are you sure you want to approve?`
          : formField?.status === 'REJECTED'
            ? 'Are you sure you want to reject?'
            : 'Are you sure you want to cancel?',
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        setSubmitAPIStatus((prev: any) => ({ ...prev, loading: true }))
        // handleLeaveAction(formField).then((res: any) => {
        //   if (res.statusCode === 200) {
        //     getLeave(formField.currentUser, setLeave, setAPIStatus, action)
        //     fetchData()
        //     setReason('')
        //     setReasonModal(null)
        //     setError('')
        //     toast.success(res.message)
        //     setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }))
        //   } else {
        //     Message(res.message, 'error')
        //     setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }))
        //   }
        // })
        handleLeaveAction(formField).then(async (res: any) => {
          // Show warning popup
          if (res.data?.warning) {
            const result = await Swal.fire({
              icon: "warning",
              title: "Leave Policy",
              // text: res.message,
              // text: res.data.message,
              html: `
                <div style="color:#FFD54F; font-size:18px; font-weight:500;">
                  ${res.data.message}
                </div>
              `,
              showCancelButton: true,
              confirmButtonText: "Approve Anyway",
              cancelButtonText: "Cancel",
            });
            if (result.isConfirmed) {
              const approveResponse = await handleLeaveAction({
                ...formField,
                ignoreClValidation: true,
              });

              if (approveResponse.statusCode === 200) {
                getLeave(formField.currentUser, setLeave, setAPIStatus, action);
                fetchData();
                setReason("");
                setReasonModal(null);
                setError("");
                toast.success(approveResponse.message);
              } else {
                Message(approveResponse.message, "error");
              }
            }
            setSubmitAPIStatus((prev: any) => ({
              ...prev,
              loading: false,
            }));
            return;
          }

          if (res.statusCode === 200) {
            getLeave(formField.currentUser, setLeave, setAPIStatus, action);
            fetchData();
            setReason("");
            setReasonModal(null);
            setError("");
            toast.success(res.message);
          } else {
            Message(res.message, "error");
          }

          setSubmitAPIStatus((prev: any) => ({
            ...prev,
            loading: false,
          }));

        });
      }
    })
  }
}
export const handleLeaveReject = async (
  leaveId,
  currentUser,
  setLeave,
  setAPIStatus,
  action,
  fetchData
) => {
  Swal.fire({
    ...AlertProps,
    icon: 'warning',
    title: `Are you sure you want to declined?`,
  }).then(async (result: any) => {
    if (result.isConfirmed) {
      handleLeaveRejects(leaveId, currentUser).then((res: any) => {
        if (res.statusCode === 200) {
          getLeave(currentUser, setLeave, setAPIStatus, action)
          fetchData()

          toast.success(res.message)
        } else {
          Message(res.message, 'error')
        }
      })
    }
  })
}

export const formatCreateAt = (dateString) => {
  if (!dateString) return '-'

  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }

  const formattedDate = new Date(dateString).toLocaleString('en-US', options)
  return formattedDate
}
export function formatDateTime(dateString) {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  }
  const formattedDate = new Date(dateString).toLocaleDateString('en-US', options)
  return formattedDate
}

export const getallUsersLeave = (setUserBalance: Function, setAPIStatus: Function) => {
  setAPIStatus((prev: any) => ({ ...prev, loading: true }))
  getallUsersLeaves().then((res: any) => {
    if (res.statusCode === 200) {
      setUserBalance(res.data)
      setAPIStatus((prev: any) => ({ ...prev, loading: false }))
    } else {
      setAPIStatus((prev: any) => ({ ...prev, loading: false, error: res.message }))
    }
  })
}
export const getLeaveBalanceById = (id: string, setEditId: Function) => {
  getLeaveBalancesById(id).then((res: any) => {
    if (res) {
      setEditId(id)
      window.scrollTo(0, 0)
    } else {
      Message(res.message, 'error')
    }
  })
}
export const cancelSubmit = (
  setInputField: Function,
  InputField: {
    leaveType: string
    leaveDate: {
      startDate: string
      endDate: string
      type: string
      approvedBy: {
        id: string
      }
    }
    sender: {
      id: string
    }
  },
  setEditId: Function,
  setInputError: Function
) => {
  setEditId(null)
  setInputField(InputField)
  setInputError({})
}

export const addManualLeaves = (
  inputField: {
    leaveType: string
    leaveDate: {
      startDate: string
      endDate: string
      type: string
      approvedBy: {
        id: string
      }
    }
    sender: {
      id: string
    }
  },
  currentUser,
  setUserBalance: Function,
  setEditId: Function,
  initialState: {
    leaveType: string
    leaveDate: {
      startDate: string
      endDate: string
      type: string
      approvedBy: {
        id: string
      }
    }
    sender: {
      id: string
    }
  },
  setInputField: Function,
  editId: string | null,
  setAPIStatus: Function,
  setInputError: Function,
  validateFormFields: Function,
  setReasonModalOpen: Function,
  fetchData: Function
) => {
  let { cnt, errors } = validateFormFields(inputField)
  setInputError(errors)

  if (cnt === 0) {
    addManualLeave(inputField, editId, currentUser).then((res) => {
      if (res.statusCode === 200) {
        getallUsersLeave(setUserBalance, setAPIStatus)
        setReasonModalOpen(false)
        setEditId(null)
        fetchData()
        setInputField(initialState)
        setInputError({})
        toast.success(res.message)
      } else {
        Message(res.message, 'error')
      }
    })
  }
}

export const validateFormFields = (inputField: {
  leaveType: string
  leaveDate: {
    startDate: string
    endDate: string
    type: string
    approvedBy: {
      id: string
    }
    sender: {
      id: string
    }
  }
}) => {
  let cnt = 0
  const errors: any = {}

  if (!inputField.leaveType) {
    cnt = cnt + 1
    errors.leaveType = 'Please select a Subject.'
  }

  if (!inputField.leaveDate.startDate) {
    cnt = cnt + 1
    errors.startDate = 'Please select/enter a Start Date.'
  }

  if (!inputField.leaveDate.endDate) {
    cnt = cnt + 1
    errors.endDate = 'Please select/enter an End Date.'
  } else if (new Date(inputField.leaveDate.endDate) < new Date(inputField.leaveDate.startDate)) {
    cnt = cnt + 1
    errors.endDate = 'End Date must not be earlier than the Start Date.'
  }

  if (!inputField.leaveDate.type) {
    cnt = cnt + 1
    errors.type = 'Please select a Type.'
  }

  return { errors, cnt }
}

